import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import AgentSvg from "../../assets/navbar/Regional_on_light_blue.svg";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import api from "../../services/api";
import regional from "../../services/regional";
import convenioService from "../../services/convenio";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import history from "../../utils/history";

import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import BorderedAutoCompleteSearch from "../../components/BorderedAutoCompleteSearch";
import TextArea from "../../components/TextArea";
import ListLog from "../../components/ListLog";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function RegionalRegistration() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const [convenioId, setConvenioId] = useState(null);
  const [selected, setSelected] = useState(false);
  const [initialState, setInitialState] = useState({
    id: null,
    pessoaId: null,
    cpfCnpj: "",
    nome: "",
    nomeFantasia: "",
    municipio: "",
    uf: "",
    nomeRegional: "",
    codigoIntegracaoFinanceira: "",
    convenio: "",
    nomeConvenio: "",
    filteredConvenio: "",
    status: true,
    observacao: "",
  });
  const [editingPerson, setEditingPerson] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupActivateOpen, setPopupActivateOpen] = useState(false);
  const [listConvenio, setListConvenio] = useState([]);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const globalContext = useContext(Context);

  async function onBlurCnpj(cnpj) {
    let typePerson = "PESSOA_FISICA";
    if (cnpj.length === 14) {
      typePerson = "PESSOA_JURIDICA";
    }
    globalContext.setIsLoading(true);

    try {
      const response = await api.get(
        `api/pessoa/buscar?cpfCnpjOuNome=${cnpj}&tipoPessoa=${typePerson}`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        const enderecos = content?.[0]?.enderecos;
        let municipio =
          content?.[0]?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
        let uf =
          content?.[0]?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
        if (enderecos && enderecos.length > 1) {
          municipio =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.descricao?.toUpperCase();
          uf =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.estado?.nome?.toUpperCase();
        }

        setInitialState({
          ...initialState,
          cpfCnpj: content?.[0]?.cpfCnpj,
          pessoaId: content?.[0]?.id,
          nome: content?.[0]?.nome,
          nomeFantasia: content?.[0]?.nomeFantasia,
          municipio: municipio,
          uf: uf,
        });
      } else if (!response) {
        setInitialState({
          ...initialState,
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function getAllConevnio() {
    globalContext.setIsLoading(true);

    try {
      const response = await api.get(
        `api/convenio/buscar?cnpjOuNome=&page=0&size=2000`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content || [];
        setListConvenio(content);
      } else if (!response) {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function getDataByUserId() {
    globalContext.setIsLoading(true);
    await regional
      .listData(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          setConvenioId(data?.convenio?.id || null);
          getConvenioById(data?.convenio?.id, data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados!");
        }
      })
      .finally(() => globalContext.setIsLoading(false));
  }

  async function getConvenioById(id, dataRegional) {
    if (!id) return;

    let convenio;
    let nomeConvenio;
    let observacao;

    try {
      const response = await convenioService.findById(id);
      if (response.status === 200 || response.status === 201) {
        const data = response?.data;
        convenio = data?.pessoa?.cpfCnpj;
        nomeConvenio = data?.nomeConvenio;
        observacao = response?.observacao;
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar dados do convênio.");
      }
    }

    const cpfCnpj = dataRegional?.pessoa?.cpfCnpj;
    const _id = dataRegional?.id;
    const pessoaId = dataRegional?.pessoa?.id;
    const nome = dataRegional?.pessoa?.nome;
    const nomeFantasia = dataRegional?.pessoa?.nomeFantasia;

    const enderecos = dataRegional?.pessoa?.enderecos;
    let municipio =
      dataRegional?.pessoa?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
    let uf =
      dataRegional?.pessoa?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
    if (enderecos && enderecos.length > 0) {
      municipio =
        dataRegional?.pessoa?.enderecos?.[
          enderecos?.length - 1
        ]?.municipio?.descricao?.toUpperCase();
      uf =
        dataRegional?.pessoa?.enderecos?.[
          enderecos?.length - 1
        ]?.municipio?.estado?.nome?.toUpperCase();
    }

    const codigoIntegracaoFinanceira = dataRegional?.codIntegracaoFin;
    const nomeRegional = dataRegional?.nomeRegional;

    setInitialState({
      ...initialState,
      cpfCnpj: cpfCnpj,
      id: _id,
      pessoaId: pessoaId,
      nome: nome,
      nomeFantasia: nomeFantasia,
      municipio: municipio,
      uf: uf,
      nomeRegional: nomeRegional,
      codigoIntegracaoFinanceira: codigoIntegracaoFinanceira,
      convenio: convenio,
      nomeConvenio: nomeConvenio,
      filteredConvenio: nomeConvenio + " - " + convenio,
      status: dataRegional?.status,
      observacao: dataRegional?.observacao,
    });
  }

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }

    id !== undefined && setEditingPerson(true);
  }, [id]);

  useEffect(() => getAllConevnio(), []);

  const sendData = async (dataForm) => {
    if (!dataForm.pessoaId || dataForm.pessoaId === null) {
      toast.error("Digite um cnpj válido.");
      return;
    }

    if (!convenioId || convenioId === null) {
      toast.error("Digite um convênio válido.");
      return;
    }
    globalContext.setIsLoading(true);

    const dataSending = {
      id: dataForm?.id,
      nomeRegional: dataForm?.nomeRegional,
      codIntegracaoFin: dataForm?.codigoIntegracaoFinanceira,
      convenio:
        convenioId !== null
          ? {
              id: convenioId,
            }
          : null,
      pessoa: {
        id: dataForm.pessoaId,
      },
      status: true,
      observacao: dataForm.observacao,
    };

    const handleEditing = async () => {
      try {
        const response = await regional.editingData(dataForm?.id, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          getDataByUserId();
          toast.success("Dados atualizados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    const handleCreate = async () => {
      try {
        const response = await regional.sendData(dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados cadastrados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (id) {
      handleEditing();
    } else {
      handleCreate();
    }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };
  const selectAutocomplete = async (item) => {
    if (typeof item === "string") return;

    setSelected(true);
    setConvenioId(item?.id);
    setInitialState({
      ...initialState,
      convenio: item?.cpfCnpj || "",
      nomeConvenio: item?.nome || "",
    });
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={AgentSvg} />
            <div>
              <S.Title>Regional</S.Title>
              <S.Description>Cadastro geral de regionais</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
            onSubmit={(values) => handleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="50%"
                        label="CPF/CNPJ*:"
                        maskChar=""
                        currentType="cpf/cnpj"
                        currency="false"
                        disabled={id && initialState.status === false}
                        error={errors.cpfCnpj && touched.cpfCnpj}
                        onBlur={(e) => {
                          onBlurCnpj(desmaskIfNumber(e.target.value));
                          setFieldValue("cpfCnpj", e.target.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <p>{errors.cpfCnpj}</p>
                <S.InputBox>
                  <Field
                    name="nome"
                    id="nome"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Nome/Razão social*:"
                          currency="false"
                          error={errors.nome && touched.nome}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeFantasia"
                    id="nomeFantasia"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Nome fantasia*:"
                          currency="false"
                          error={errors.nomeFantasia && touched.nomeFantasia}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="municipio"
                    id="municipio"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Cidade:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="uf"
                    id="uf"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
                <S.InputBox>
                  <Field
                    name="nomeRegional"
                    id="nomeRegional"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Nome da regional:"
                          type="text"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              nomeRegional: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.TextAreaBox>
                  <Field
                    name="observacao"
                    id="observacao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <TextArea
                          {...field}
                          type="text"
                          label="Observação:"
                          onChange={(e) => {
                            setFieldValue("observacao", e.target.value);
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.TextAreaBox>

                <S.InputBox>
                  <Field
                    name="codigoIntegracaoFinanceira"
                    id="codigoIntegracaoFinanceira"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Código de Integração Financeira:"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              codigoIntegracaoFinanceira: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeConvenio"
                    id="nomeConvenio"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <BorderedAutoCompleteSearch
                          title="Convênio"
                          label="Selecione seu convênio"
                          listConvenio={listConvenio}
                          selected={selected}
                          handleSearch={selectAutocomplete}
                          initialValue={initialState.filteredConvenio}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <S.ButtonExclude>
              {id && initialState.status === true ? (
                <Button
                  button="primary"
                  className="inativar"
                  onClick={() => {
                    setPopupOpen(true);
                    setUserSelected({
                      id: initialState.id,
                      cpf: initialState.cpfCnpj,
                    });
                  }}
                >
                  Inativar cadastro
                </Button>
              ) : initialState.status ? (
                <></>
              ) : (
                <Button button="primary" className="inativo">
                  Cadastro inativo
                </Button>
              )}
            </S.ButtonExclude>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {id && initialState.status === false ? (
              <Button
                button="primary"
                onClick={() => {
                  setPopupActivateOpen(true);
                  setUserSelected({
                    id: initialState.id,
                    cpf: initialState.cpfCnpj,
                    status: true,
                  });
                }}
              >
                Ativar cadastro
              </Button>
            ) : (
              <Button button="primary" onClick={() => handleSubmit()}>
                Salvar cadastro
              </Button>
            )}
          </S.ButtonContainer>
        </S.Content>
        <S.Content>
          {initialState?.id && (
            <ListLog entidadeId={initialState.id} nomeEntidade="Regional" />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Content>
      </S.Wrapper>
      {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          updateList={getDataByUserId}
          userSelected={userSelected}
          endPoint="/api/regional/"
          useMask="##.###.###/####-##"
          inativar={true}
          ativar={false}
          showCpfCnpj={false}
          textExclude={
            "Você deseja realmente inativar este cadastro e também os usuários vinculados a ele?"
          }
          messageFailed={"Error ao inativar o regional com o CNPJ"}
          messageSuccess={"Sucesso ao inativar o regional"}
        />
      )}
      {popupActivateOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupActivateOpen}
          userSelected={initialState}
          updateList={getDataByUserId}
          endPoint="/api/regional/"
          inativar={false}
          ativar={true}
          showCpfCnpj={false}
          textExclude={"Você deseja realmente ativar este cadastro?"}
          messageFailed={"Error ao regional a loja com o CNPJ"}
          messageSuccess={"Sucesso ao ativar a regional"}
        />
      )}
    </>
  );
}
